import { Component, Inject, OnInit, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ToastrService } from 'ngx-toastr';
import { DialogCloseData } from 'src/app/_model/models';
import { Overtime } from 'src/app/_model/overtime';
import { OvertimeService } from 'src/app/_services/overtime.service';
import { DIALOG_OPERATIONS } from 'src/app/_utils/constants';

@Component({
  selector: 'app-overtime-delete',
  templateUrl: './overtime-delete.component.html',
  styleUrls: ['./overtime-delete.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule
  ]
})
export class OvertimeDeleteComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<OvertimeDeleteComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Overtime,
    private overtimeService: OvertimeService,
    private toastr: ToastrService) { }

  ngOnInit() {
  }

  deleteAbsence(overtime: Overtime) {
    this.overtimeService.deleteOvertime(overtime.id).subscribe(result => {
      this.toastr.success('Silme işlemi başarılı', '');
      this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.DELETE, overtime.id));
    }, error => {
      this.toastr.error(error.error.msg, 'Hata');
      this.dialogRef.close();
    });
  }
}
